import { render } from "./DxtPackageTopUp.vue?vue&type=template&id=fafaa1e8&scoped=true"
import script from "./DxtPackageTopUp.vue?vue&type=script&lang=js"
export * from "./DxtPackageTopUp.vue?vue&type=script&lang=js"

import "./DxtPackageTopUp.vue?vue&type=style&index=0&id=fafaa1e8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fafaa1e8"

export default script